import { noop } from 'lodash';
import React from 'react';

import { AppContextStateType } from '~/types';

export const appContextInitialState: AppContextStateType = {
  deviceId: '',
  deviceIdIsLoading: true,
  examineePhotoIsLoading: false,
  examineePhotoSrc: '',
  extensionVersion: undefined,
  isKioskMode: undefined,
  operatingSystem: undefined,
  registrationId: undefined,
  testCenterDrawerIsOpen: true,
  testCenterId: undefined,
  user: undefined,
  registrationDetails: '',
};

export const AppContext = React.createContext({
  actions: {
    /* eslint-disable @typescript-eslint/no-unused-vars, lodash/no-extra-args */
    update: async (context: Partial<AppContextStateType>): Promise<void> => {
      await Promise.resolve(noop(context));
    },
    /* eslint-enable @typescript-eslint/no-unused-vars, lodash/no-extra-args */
  },
  state: appContextInitialState,
});

export type AppContextType = React.ContextType<typeof AppContext>;

export default AppContext;
